import ProjectPricingItem from '../../../Domain/ProjectPricingItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import PricingService from '../../../Services/PricingService';

class AddProjectPricingCreateWindowDescription {
  static titleForCreate = 'Add New Client Fee';
  static titleForEdit = 'Edit Client Fee';
  static finishButtonLabel = 'OK';
  static itemType = ProjectPricingItem;
  static serviceFunction = (edited) => PricingService.AddProjectPricing(edited);
  static messageOnSuccess = 'Client fee has been created.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'CountryId',
          label: 'Country',
          className: 'col-12',
          type: InputTypesEnum.CountrySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'OfficeId',
          label: 'Fieldwork Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];
}

export default AddProjectPricingCreateWindowDescription;
